import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

import MultiBy10 from './MultiBy/MultiBy10'
import MultiBy10Deci from './MultiBy/MultiBy10Deci'
import RoundMulti from './MultiBy/RoundMulti'
import RoundMultiDecimal from './MultiBy/RoundMultiDecimal'

const Bootcamp4Activities = ({ activityName, ...props }: ActivityGroupProps): React.ReactElement => {
  switch (activityName) {
    case 'MultiBy10Deci':
      return <MultiBy10Deci {...props} />
    case 'MultiBy10':
      return <MultiBy10 {...props} />
    case 'RoundMulti':
      return <RoundMulti {...props} />
    case 'RoundMultiDecimal':
      return <RoundMultiDecimal {...props} />
    default:
      return <></>
  }
}

export default Bootcamp4Activities
